import React, { Component } from 'react';
import './AIUsers.css';

class AIUsers extends Component {
  render() {
    if (this.props.data) {
      let aiUsers = this.props.data.map(aiUser => {
        return (
          <tr>
            <td>{aiUser.id}</td>
            <td>
              {
                aiUser['urn:avalara:schemas:extension:2.0:AvalaraUser']
                  ?.subjectId
              }
            </td>
            <td>
              {
                aiUser['urn:avalara:schemas:extension:2.0:AvalaraUser']
                  ?.defaultTenant?.identifier
              }
            </td>
            <td>{aiUser.displayName}</td>
            <td>{aiUser.userName}</td>
            <td>{aiUser.userName}</td>
            <td>
              {new Date(aiUser.meta.created).toLocaleDateString('en-US', {
                hour: '2-digit',
                minute: '2-digit'
              })}
            </td>
          </tr>
        );
      });

      return (
        <table>
          <thead>
            <tr>
              <td>Id</td>
              <td>SubjectId</td>
              <td>TenantId</td>
              <td>Name</td>
              <td>Username</td>
              <td>Email</td>
              <td>Created Date</td>
            </tr>
          </thead>
          <tbody>{aiUsers}</tbody>
        </table>
      );
    } else {
      return false;
    }
  }
}

export default AIUsers;
